import React, { FunctionComponent } from 'react';

import {
  Typography as Typo
} from '@mui/material';

var he = require('he');

type TypographyProps = {
  sx?: object;
  onClick?: (e:unknown) => void;
  children: React.ReactNode | string;
  fuck_p_tags?: boolean;
  html?: boolean;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined;
};

export const Typography: FunctionComponent<TypographyProps> = ({variant, sx, children, onClick, html, fuck_p_tags}) => {
  return (!!html && typeof(children) === "string" ? <Typo
    variant={variant}
    sx={{
      "& > table": {
        width: '100%'
      },
      "& div > figure": {
        textAlign: 'center'
      },
      "table td > div > figure": {
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      "& > p": (!!fuck_p_tags ? {
        marginTop: 0,
        marginBottom: 0
      } : {}),
      ...sx
    }}
    onClick={(e) => {if (!!onClick) onClick(e);}}
    dangerouslySetInnerHTML={{ __html: children }}
  ></Typo> : <Typo
    variant={variant}
    sx={sx}
    onClick={(e) => {if (!!onClick) onClick(e);}}
  >
    {typeof(children) === "string" ? he.decode(children.replace(/<[^>]*>?/gm, '')) : children}
  </Typo>);
}